import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper, Alert } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import RefreshIcon from '@mui/icons-material/Refresh';
import HomeIcon from '@mui/icons-material/Home';

const InternalErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            p: { xs: 4, sm: 6 },
            textAlign: 'center',
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
              animation: 'pulse 2s ease-in-out infinite',
              '@keyframes pulse': {
                '0%, 100%': { opacity: 1, transform: 'scale(1)' },
                '50%': { opacity: 0.7, transform: 'scale(1.05)' },
              },
            }}
          >
            <WarningIcon sx={{ fontSize: 100, color: '#f5576c' }} />
          </Box>

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '3rem', sm: '4rem' },
              fontWeight: 'bold',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 1,
            }}
          >
            500
          </Typography>

          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            Interner Serverfehler
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#666',
              mb: 3,
              lineHeight: 1.8,
            }}
          >
            Ein unerwarteter Fehler ist auf dem Server aufgetreten.
            <br />
            Unser Team wurde benachrichtigt und arbeitet an der Lösung.
          </Typography>

          <Alert severity="info" sx={{ mb: 3, justifyContent: 'flex-start' }}>
            <Typography variant="body2">
              Versuchen Sie die Seite zu aktualisieren oder kommen Sie später zurück.
            </Typography>
          </Alert>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<RefreshIcon />}
              onClick={() => window.location.reload()}
              sx={{
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Seite neu laden
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{
                borderColor: '#f5576c',
                color: '#f5576c',
                textTransform: 'none',
                fontSize: '1rem',
                '&:hover': {
                  borderColor: '#f093fb',
                  backgroundColor: 'rgba(245, 87, 108, 0.1)',
                },
              }}
            >
              Zur Startseite
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default InternalErrorPage;
